import { useEffect, useState } from "react";
import { getCachedImage, fallbackImage } from "../utils/getCachedImage";

export function useCachedImagesArray(participants) {
  const [images, setImages] = useState(
    participants && participants.length > 0
      ? Array(participants.length).fill(fallbackImage)
      : [],
  );

  useEffect(() => {
    let isMounted = true;
    if (!participants || participants.length === 0) {
      setImages([]);
      return;
    }
    // Set fallback images immediately while loading
    setImages(Array(participants.length).fill(fallbackImage));
    Promise.all(
      participants.map((p) => {
        const imageUrl =
          p.profileImageUrl ||
          `https://api.dicebear.com/8.x/miniavs/svg?seed=${encodeURIComponent(p.username)}`;
        let initialLetter =
          p.username && p.username.length > 0 ? p.username.charAt(0) : "";
        if (!initialLetter) {
          initialLetter =
            p.id && p.id.toString().length > 0 ? p.id.toString().charAt(0) : "";
        }
        return getCachedImage(imageUrl, initialLetter).catch(
          () => fallbackImage,
        );
      }),
    ).then((imgs) => {
      if (isMounted) setImages(imgs);
    });
    return () => {
      isMounted = false;
    };
  }, [participants]);

  return images;
}
